import React from 'react';
import logo from './logo.svg';
import './App.css';
import CompareTable from './components/compareTable';

function App() {
    return (
        <CompareTable/>
    )
}

export default App;
